import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { createApiResponseSchema } from '../../../utils';
import { partnerApiPath } from '../../apiPath';
import { partnerHttpClient } from '../../httpClient';

const GetCampaignResultCountsRequestSchema = z
  .object({
    campaignId: z.union([z.number(), z.string()]),
  })
  .describe('GetCampaignResultCountsRequestSchema');

export type GetCampaignResultCountsRequest = z.infer<typeof GetCampaignResultCountsRequestSchema>;

const GetCampaignResultCountsResponseDataSchema = z
  .object({
    completedCount: z.number(),
    incompleteCount: z.number(),
  })
  .describe('GetCampaignResultCountsResponseDataSchema');

export type CampaignResultCounts = z.infer<typeof GetCampaignResultCountsResponseDataSchema>;

const GetCampaignResultCountsResponseSchema = createApiResponseSchema(
  GetCampaignResultCountsResponseDataSchema,
);

export type GetCampaignResultCountsResponse = z.infer<typeof GetCampaignResultCountsResponseSchema>;

export const getCampaignResultCounts = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetCampaignResultCountsRequestSchema),
    async ({ campaignId }: GetCampaignResultCountsRequest) =>
      executeStandardRequest(async () =>
        partnerHttpClient.get<GetCampaignResultCountsResponse>(
          partnerApiPath.getCampaignResultCounts(campaignId),
        ),
      ),
    validateApiResponse(GetCampaignResultCountsResponseSchema),
  ),
);
